export default "__VITE_ASSET__65c16866__"